/**
 * @doc https://github.com/Cuberto/mouse-follower
 */

import MouseFollower from "mouse-follower";
import gsap from "gsap";

MouseFollower.registerGSAP(gsap);

export default function initMouseFollower() {
    new MouseFollower();
}
